import React from "react";
import { EmptyState, PortalLoading, StatusBadge, StudentPageHeader, money, niceDate, useStudentPortal } from "./studentPortalUtils";

function StudentLibraryPage() {
  const { data, loading, reload } = useStudentPortal("student-portal/library/");
  if (loading && !data) return <PortalLoading />;

  const rows = data?.borrowings || [];

  return (
    <div className="container-fluid py-4">
      <StudentPageHeader
        title="My Library"
        subtitle={`${data?.borrowed_count || 0} currently borrowed · ${data?.overdue_count || 0} overdue`}
        icon="bi-book"
        actions={<button className="btn btn-light border" onClick={reload}>Refresh</button>}
      />

      <div className="alert alert-light border d-flex gap-3 align-items-start">
        <i className="bi bi-info-circle text-success fs-4"></i>
        <div>
          <strong>Library borrowing process</strong>
          <div className="small text-muted">
            This page shows your borrowing history, due dates, returns and fines. Physical books are still issued and returned by the library desk so the librarian can verify availability and book condition. A request/reservation button can be added later without changing the official checkout process.
          </div>
        </div>
      </div>

      <div className="card border-0 shadow-sm">
        <div className="card-body">
          {rows.length === 0 ? (
            <EmptyState title="No library history" />
          ) : (
            <div className="table-responsive">
              <table className="table align-middle">
                <thead className="table-light">
                  <tr>
                    <th>Title</th>
                    <th>Author</th>
                    <th>Borrowed</th>
                    <th>Due</th>
                    <th>Returned</th>
                    <th>Fine</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.id} className={row.is_overdue ? "table-warning" : ""}>
                      <td className="fw-semibold">{row.title}</td>
                      <td>{row.author || "-"}</td>
                      <td>{niceDate(row.borrowed_date)}</td>
                      <td>{niceDate(row.due_date)}</td>
                      <td>{niceDate(row.returned_date)}</td>
                      <td>{money(row.fine_amount)}</td>
                      <td><StatusBadge value={row.is_overdue ? "OVERDUE" : row.status} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default StudentLibraryPage;
